export default __webpack_public_path__ + "static/media/weightlosswithfamily_2.e62fa215.jpg";